export const SEARCH_DELAY = 700;
